module.exports = __webpack_public_path__ + "img/on-demand-white.77f81139.svg";